import { Button, MenuItem, Select } from '@mui/material'
import { Country } from 'country-state-city'
import { ICountry } from 'country-state-city/lib/interface'
import { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { UserDataContext } from '../../../providers/contexts/UserDataProvider'
import { updateAccount } from '../../../services/syndeo-dashboard/user'
import { COUNTRY_NAMES } from '../../../utils/constants/country-name-translations'
import { useIpCountry } from '../../../utils/hooks/useIpCountry'
import {
    parsePreferenceFlags,
    useUser,
} from '../../dashboard/account-settings/_hooks'
import CustomModal from '../custom-modal'
import './countrySelectModal.scss'

const CountrySelectModal = () => {
    const { t } = useTranslation()
    const Countries: ICountry[] = Country.getAllCountries()
    const { setUserData } = useContext(UserDataContext)

    const [selectedCountry] = useIpCountry()
    const { formikInitialValues: values } = useUser()
    const [country, setCountry] = useState(
        selectedCountry?.isoCode.toLowerCase()
    )
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [error, setError] = useState(false)

    const onSubmit = async () => {
        setIsSubmitting(true)
        setError(false)
        const data = {
            birthDate: values.birthday,
            businessName: values.businessName,
            beautyHealthCustomerId: values.beautyHealthCustomerId,
            country: country,
            email: values.email,
            firstName: values.firstname,
            lastName: values.lastname,
            mobile: values.mobilenumber,
            ...parsePreferenceFlags(values.selectPreferences),
            userRole: values.userRole,
        }
        try {
            const response: any = await updateAccount(data)
            if (response && response.success) {
                setUserData(response.data)
            }
        } catch (e) {
            setError(true)
        } finally {
            setIsSubmitting(false)
        }
    }

    return (
        <CustomModal open={true}>
            <div className={'header'}>
                <h1 className={'title'}>
                    {t('country_selection_modal.country_selection_modal_title')}
                </h1>
            </div>
            <div className={'main'}>
                <p>
                    {t(
                        'country_selection_modal.country_selection_modal_content'
                    )}
                </p>
                <div className={'countrySelectContainer'}>
                    <Select
                        className="countrySelectDropDown"
                        autoWidth
                        value={country}
                        onChange={(e) => {
                            setCountry(e.target.value)
                        }}
                        renderValue={(selected) =>
                            selected &&
                            `${t('sign_in_page.located_in_text')} ${
                                Countries.find(
                                    (country) =>
                                        country.isoCode.toLowerCase() ===
                                        selected.toLowerCase()
                                )?.flag
                            }`
                        }
                        MenuProps={{
                            className: 'country-select-menu',
                        }}
                    >
                        {Countries.map((country) => (
                            <MenuItem
                                key={country.isoCode.toLowerCase()}
                                value={country.isoCode.toLowerCase()}
                                className={'country-name'}
                            >
                                <span>{country.flag} </span>
                                <span>
                                    {(COUNTRY_NAMES as any)[country.isoCode]}
                                </span>
                            </MenuItem>
                        ))}
                    </Select>
                </div>
                <div className="button-container">
                    <Button
                        variant="contained"
                        className="secondary-btn button-req"
                        onClick={onSubmit}
                        disabled={isSubmitting}
                    >
                        {isSubmitting
                            ? t('client_rewards_tracking.confirming')
                            : t('common_elements.confirm')}
                    </Button>
                    {error && !isSubmitting && (
                        <p className="button-error">
                            {t('common_elements.something_wrong_text')}
                        </p>
                    )}
                </div>
            </div>
        </CustomModal>
    )
}

export default CountrySelectModal
